import React from 'react'
import { useTranslation } from 'react-i18next'
import { CopilotStep } from './lib/copilotTypes'
import { AGENTS } from './lib/agents'
import { VoiceWaveIcon, ChampBotIcon, SparkIcon } from './icons'
import { cx } from './cx'
import styles from './index.module.scss'

/** simple bouncing-dots indicator (shown before the first trace arrives) */
export const ThinkingDots: React.FC = () => {
  const { t } = useTranslation()
  return (
    <div className={styles.thinking}>
      <div className={styles.miniAvatar}>
        <VoiceWaveIcon />
      </div>
      <div className={styles.thinkBody}>
        <div className={styles.traceText}>{t('genAI.copilot-thinking')}</div>
        <div className={styles.dots}>
          <i />
          <i />
          <i />
        </div>
      </div>
    </div>
  )
}

interface TraceStepsProps {
  steps: CopilotStep[]
}

/** agent-routing preview driven by real trace events */
const TraceSteps: React.FC<TraceStepsProps> = ({ steps }) => (
  <div className={styles.thinking}>
    <div className={styles.miniAvatar}>
      <VoiceWaveIcon />
    </div>
    <div className={styles.steps}>
      {steps.map((s) => (
        <div key={s.id} className={cx(styles.step, s.done ? styles.stepDone : styles.stepActive)}>
          <span
            className={cx(styles.stepIco, s.kind === 'generic' && styles.stepIcoChamp)}
            style={s.kind === 'agent' && s.color ? { background: s.color } : undefined}>
            {s.kind === 'agent' && s.color ? <ChampBotIcon color={s.color} /> : <SparkIcon />}
          </span>
          <span className={styles.stepText}>
            <span className={styles.stepLabel}>{s.label}</span>
            {s.kind === 'agent' && s.agentKey && AGENTS[s.agentKey] && (
              <span className={styles.stepAgent} style={{ color: s.color, background: `${s.color}1f` }}>
                {AGENTS[s.agentKey].label}
              </span>
            )}
          </span>
          <span className={styles.stepSpin} />
        </div>
      ))}
    </div>
  </div>
)

export default TraceSteps
